/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createVacancy = /* GraphQL */ `
  mutation CreateVacancy($input: CreateVacancyInput!, $condition: ModelVacancyConditionInput) {
    createVacancy(input: $input, condition: $condition) {
      id
      title
      location
      employment
      summary
      description
      hidden
      reactions {
        items {
          id
          vacancyID
          name
          email
          phoneNumber
          message
          cvFileKey
        }
        nextToken
      }
    }
  }
`
export const updateVacancy = /* GraphQL */ `
  mutation UpdateVacancy($input: UpdateVacancyInput!, $condition: ModelVacancyConditionInput) {
    updateVacancy(input: $input, condition: $condition) {
      id
      title
      location
      employment
      summary
      description
      hidden
    }
  }
`
export const deleteVacancy = /* GraphQL */ `
  mutation DeleteVacancy($input: DeleteVacancyInput!, $condition: ModelVacancyConditionInput) {
    deleteVacancy(input: $input, condition: $condition) {
      id
      title
      location
      employment
      summary
      description
      hidden
      reactions {
        items {
          id
          vacancyID
          name
          email
          phoneNumber
          message
          cvFileKey
        }
        nextToken
      }
    }
  }
`
export const updateVacancyReaction = /* GraphQL */ `
  mutation UpdateVacancyReaction(
    $input: UpdateVacancyReactionInput!
    $condition: ModelVacancyReactionConditionInput
  ) {
    updateVacancyReaction(input: $input, condition: $condition) {
      id
      vacancyID
      name
      email
      phoneNumber
      message
      cvFileKey
    }
  }
`
export const deleteVacancyReaction = /* GraphQL */ `
  mutation DeleteVacancyReaction(
    $input: DeleteVacancyReactionInput!
    $condition: ModelVacancyReactionConditionInput
  ) {
    deleteVacancyReaction(input: $input, condition: $condition) {
      id
      vacancyID
      name
      email
      phoneNumber
      message
      cvFileKey
    }
  }
`
export const createVacancyReaction = /* GraphQL */ `
  mutation CreateVacancyReaction(
    $input: CreateVacancyReactionInput!
    $condition: ModelVacancyReactionConditionInput
  ) {
    createVacancyReaction(input: $input, condition: $condition) {
      id
      vacancyID
      name
      email
      phoneNumber
      message
      cvFileKey
    }
  }
`
